import { FC, useMemo, useState } from 'react';
import { PagesTable } from 'components/CustomTable/PagesTable';
import { useAppSelector } from 'helpers/hooks';
import { getPageActions, getPagePreviewUrl, useHandlePageUpdate } from 'views/Pages/utils';
import { communityPageColumns } from 'constants/tables';
import { getSubscriptionLevel } from 'selectors/partners';
import { useAdminAuth } from 'hooks/useAdminAuth';
import { useGetSetsQuery } from 'services/setsApi';

interface Props {
  category: string;
}

export const CommunityPages: FC<Props> = ({ category }) => {
  const handleUpdate = useHandlePageUpdate(category);
  const [popupType, setPopupType] = useState('');
  const { clientId, activeRole, hasClient, isSuper } = useAdminAuth();
  const subscriptionLevel = useAppSelector(getSubscriptionLevel);

  // Super's "ALL" (0) lists every client's sets (client_id omitted); others are client-scoped.
  const { data: setsData = [], isLoading: setsLoading } = useGetSetsQuery(
    { client_id: clientId ?? 0 },
    { skip: !hasClient && !isSuper }
  );

  const dataState = useMemo(() => {
    if (!setsLoading && setsData?.length) {
      return setsData.map((prop, key) => ({
        id: key,
        querystring: prop.querystring,
        set_title: prop.set_title,
        webUrl: getPagePreviewUrl(category, prop.querystring),
        actions: getPageActions(category, activeRole, handleUpdate, prop, subscriptionLevel),
      }));
    }
    return [];
  }, [setsData, setsLoading, category, activeRole, handleUpdate]);

  return (
    <PagesTable
      data={dataState}
      category={category}
      isLoading={setsLoading}
      popupType={popupType}
      setPopupType={setPopupType}
      pageColumns={communityPageColumns}
      subscriptionLevel={subscriptionLevel}
    />
  );
};
